import { render, staticRenderFns } from "./ques52.vue?vue&type=template&id=367cb428&scoped=true"
import script from "./ques52.vue?vue&type=script&lang=js"
export * from "./ques52.vue?vue&type=script&lang=js"
import style0 from "./ques52.vue?vue&type=style&index=0&id=367cb428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367cb428",
  null
  
)

export default component.exports